import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const bank: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.5-12 15-9v1h-1a.5.5 0 0 1-.156.36.55.55 0 0 1-.375.14H1.547a.6.6 0 0 1-.39-.14A.48.48 0 0 1 1-8H0v-1zM2-7h2v6h1v-6h2v6h1v-6h2v6h1v-6h2v6h.469c.144 0 .27.055.375.156.101.094.156.211.156.344V0H1v-.5q-.001-.201.156-.344A.57.57 0 0 1 1.546-1H2zM14.469.5q.217 0 .375.14A.5.5 0 0 1 15 1v1H0V1Q-.001.794.156.64A.6.6 0 0 1 .546.5zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "15",
  }
};